// المنطقة من الإحداثيات — **بلا خدمة خارجية** (قرار المالك: يريد أن يقرأ «مدينة نصر» لا أرقامًا).
//
// لا نرسل إحداثيات موظف إلى Google ولا OSM: الجدول هنا مراكز أحياء القاهرة الكبرى ومدن مصر،
// والأقرب منها هو الجواب. تقريبٌ صادق يقوله النص نفسه: «في مدينة نصر» إن كان داخل نطاق
// الحي، و«قرب مدينة نصر» إن كان على أطرافه، و«خارج المناطق المعروفة» إن بَعُد عن الكل.
// والدقّة كافية لغرضها — أين بصم الموظف — لا لعنوان شارع؛ ورابط الخريطة لمن أراد التفصيل.

export interface GeoArea { name: string; city: string; lat: number; lon: number; kind: 'DISTRICT' | 'CITY' }

/** أحياء القاهرة الكبرى (القاهرة · الجيزة · القليوبية) — مراكز تقريبية. */
const DISTRICTS: [string, string, number, number][] = [
  ['مدينة نصر', 'القاهرة', 30.0566, 31.3300], ['مصر الجديدة', 'القاهرة', 30.0880, 31.3250], ['النزهة', 'القاهرة', 30.1030, 31.3550],
  ['شيراتون', 'القاهرة', 30.1050, 31.3720], ['الدقي', 'الجيزة', 30.0385, 31.2120], ['المهندسين', 'الجيزة', 30.0570, 31.2030],
  ['الزمالك', 'القاهرة', 30.0610, 31.2220], ['وسط البلد', 'القاهرة', 30.0470, 31.2400], ['جاردن سيتي', 'القاهرة', 30.0380, 31.2320],
  ['المعادي', 'القاهرة', 29.9600, 31.2570], ['زهراء المعادي', 'القاهرة', 29.9680, 31.3050], ['حلوان', 'القاهرة', 29.8500, 31.3340],
  ['التجمع الخامس', 'القاهرة', 30.0080, 31.4300], ['الرحاب', 'القاهرة', 30.0590, 31.4910], ['مدينتي', 'القاهرة', 30.1090, 31.6300],
  ['الشروق', 'القاهرة', 30.1460, 31.6030], ['العبور', 'القليوبية', 30.2280, 31.4700], ['بدر', 'القاهرة', 30.1400, 31.7300],
  ['العاصمة الإدارية', 'القاهرة', 30.0100, 31.7500], ['شبرا', 'القاهرة', 30.0780, 31.2450], ['روض الفرج', 'القاهرة', 30.0810, 31.2360],
  ['شبرا الخيمة', 'القليوبية', 30.1280, 31.2420], ['الزاوية الحمراء', 'القاهرة', 30.0900, 31.2650], ['المطرية', 'القاهرة', 30.1210, 31.3130],
  ['عين شمس', 'القاهرة', 30.1310, 31.3220], ['الزيتون', 'القاهرة', 30.1040, 31.3120], ['حدائق القبة', 'القاهرة', 30.0860, 31.2880],
  ['العباسية', 'القاهرة', 30.0700, 31.2800], ['المرج', 'القاهرة', 30.1580, 31.3400], ['السلام', 'القاهرة', 30.1500, 31.3900],
  ['المنيل', 'القاهرة', 30.0250, 31.2270], ['مصر القديمة', 'القاهرة', 30.0060, 31.2300], ['السيدة زينب', 'القاهرة', 30.0300, 31.2380],
  ['الحسين والأزهر', 'القاهرة', 30.0470, 31.2620], ['بولاق أبو العلا', 'القاهرة', 30.0600, 31.2300], ['المقطم', 'القاهرة', 30.0100, 31.2800],
  ['البساتين', 'القاهرة', 29.9990, 31.2650], ['دار السلام', 'القاهرة', 30.0020, 31.2430], ['طرة', 'القاهرة', 29.9330, 31.2900],
  ['15 مايو', 'القاهرة', 29.8300, 31.3700], ['الجيزة', 'الجيزة', 30.0130, 31.2090], ['فيصل', 'الجيزة', 30.0050, 31.1750],
  ['الهرم', 'الجيزة', 29.9950, 31.1500], ['حدائق الأهرام', 'الجيزة', 29.9730, 31.1400], ['إمبابة', 'الجيزة', 30.0760, 31.2100],
  ['الوراق', 'الجيزة', 30.1040, 31.2170], ['المنيب', 'الجيزة', 29.9800, 31.2100], ['6 أكتوبر', 'الجيزة', 29.9600, 30.9200],
  ['الشيخ زايد', 'الجيزة', 30.0400, 30.9800], ['حدائق أكتوبر', 'الجيزة', 29.9100, 30.9700],
];

/** مدن مصر خارج القاهرة الكبرى — مراكزها. */
const CITIES: [string, number, number][] = [
  ['الإسكندرية', 31.2001, 29.9187], ['المنصورة', 31.0409, 31.3785], ['طنطا', 30.7865, 31.0004], ['الزقازيق', 30.5877, 31.5020],
  ['بنها', 30.4660, 31.1840], ['الإسماعيلية', 30.5965, 32.2715], ['بورسعيد', 31.2565, 32.2841], ['السويس', 29.9668, 32.5498],
  ['دمياط', 31.4165, 31.8133], ['كفر الشيخ', 31.1107, 30.9388], ['دمنهور', 31.0341, 30.4682], ['الفيوم', 29.3084, 30.8441],
  ['بني سويف', 29.0661, 31.0994], ['المنيا', 28.1099, 30.7503], ['أسيوط', 27.1809, 31.1837], ['سوهاج', 26.5590, 31.6957],
  ['قنا', 26.1551, 32.7160], ['الأقصر', 25.6872, 32.6396], ['أسوان', 24.0889, 32.8998], ['الغردقة', 27.2579, 33.8116],
  ['شرم الشيخ', 27.9158, 34.3300], ['مرسى مطروح', 31.3543, 27.2373], ['العريش', 31.1316, 33.7984], ['العين السخنة', 29.6000, 32.3500],
];

export const GEO_AREAS: GeoArea[] = [
  ...DISTRICTS.map(([name, city, lat, lon]) => ({ name, city, lat, lon, kind: 'DISTRICT' as const })),
  ...CITIES.map(([name, lat, lon]) => ({ name, city: name, lat, lon, kind: 'CITY' as const })),
];

/** المسافة بالكيلومتر على سطح الأرض (Haversine). */
export function distanceKm(lat1: number, lon1: number, lat2: number, lon2: number): number {
  const R = 6371, toRad = (d: number) => (d * Math.PI) / 180;
  const dLat = toRad(lat2 - lat1), dLon = toRad(lon2 - lon1);
  const a = Math.sin(dLat / 2) ** 2 + Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(a));
}

export interface AreaGuess { area: GeoArea; distanceKm: number; relation: 'IN' | 'NEAR' }

/** حي داخل ٣٫٥ كم ⇒ «في»، وإلا أقرب حي حتى ٨ كم ⇒ «قرب»؛ ومدينة داخل ٢٠ كم ⇒ «في»، وحتى ٤٥ كم ⇒ «قرب». */
export function guessArea(lat: number, lon: number): AreaGuess | null {
  let best: AreaGuess | null = null;
  for (const area of GEO_AREAS) {
    const d = distanceKm(lat, lon, area.lat, area.lon);
    const [inKm, nearKm] = area.kind === 'DISTRICT' ? [3.5, 8] : [20, 45];
    if (d > nearKm) continue;
    const relation: AreaGuess['relation'] = d <= inKm ? 'IN' : 'NEAR';
    // الأحياء أولى من المدن عند التساوي في العلاقة؛ ثم الأقرب
    const rank = (g: AreaGuess) => (g.relation === 'IN' ? 0 : 2) + (g.area.kind === 'DISTRICT' ? 0 : 1);
    const cand = { area, distanceKm: d, relation };
    if (!best || rank(cand) < rank(best) || (rank(cand) === rank(best) && d < best.distanceKm)) best = cand;
  }
  return best;
}

/** «في مدينة نصر (القاهرة)» · «قرب المعادي (القاهرة)» · «في الإسكندرية» · «خارج المناطق المعروفة». */
export function areaLabelAr(lat: number | null | undefined, lon: number | null | undefined): string {
  if (lat === null || lat === undefined || lon === null || lon === undefined) return '—';
  const g = guessArea(lat, lon);
  if (!g) return 'خارج المناطق المعروفة';
  const rel = g.relation === 'IN' ? 'في' : 'قرب';
  return g.area.kind === 'DISTRICT' ? `${rel} ${g.area.name} (${g.area.city})` : `${rel} ${g.area.name}`;
}

export interface Office { id: string; nameAr: string; lat: number; lon: number; radiusM: number }

export interface OfficeDistance { office: Office; meters: number; inside: boolean }

/** أقرب مكتب وبُعده بالمتر — والنطاق من إعداد المكتب نفسه (٥٠ مترًا افتراضًا). */
export function nearestOffice(lat: number, lon: number, offices: readonly Office[]): OfficeDistance | null {
  let best: OfficeDistance | null = null;
  for (const office of offices) {
    const meters = Math.round(distanceKm(lat, lon, office.lat, office.lon) * 1000);
    if (!best || meters < best.meters) best = { office, meters, inside: meters <= office.radiusM };
  }
  return best;
}

/** «داخل نطاق مكتب مصر الجديدة» · «يبعد ٣٢٠ م عن مكتب مصر الجديدة». */
export function officeDistanceAr(lat: number | null | undefined, lon: number | null | undefined, offices: readonly Office[]): string | null {
  if (lat === null || lat === undefined || lon === null || lon === undefined) return null;
  const d = nearestOffice(lat, lon, offices);
  if (!d) return null;
  if (d.inside) return `داخل نطاق ${d.office.nameAr}`;
  return d.meters < 1000
    ? `يبعد ${d.meters.toLocaleString('en-US')} م عن ${d.office.nameAr}`
    : `يبعد ${(d.meters / 1000).toFixed(1)} كم عن ${d.office.nameAr}`;
}

/**
 * إحداثيات من رابط خرائط جوجل كما يلصقه المالك — على صوره المعروفة:
 * `@30.09,31.34,17z` · `?q=30.09,31.34` · `!3d30.09!4d31.34` · `/place/.../@…` · أو رقمان مفصولان بفاصلة.
 * وما لم يحمل الرابط إحداثيات (روابط المشاركة القصيرة مثلًا) يُقال ذلك صراحةً ولا يُخمَّن.
 */
export function parseLatLon(input: string): { lat: number; lon: number } | null {
  const text = (() => { try { return decodeURIComponent(input.trim()); } catch { return input.trim(); } })();
  const ok = (a: string, b: string) => {
    const lat = Number(a), lon = Number(b);
    return Number.isFinite(lat) && Number.isFinite(lon) && Math.abs(lat) <= 90 && Math.abs(lon) <= 180 ? { lat, lon } : null;
  };
  const pats = [/@(-?\d+\.\d+),(-?\d+\.\d+)/, /[?&](?:q|query|ll|daddr|saddr|center)=(-?\d+\.\d+),\s*(-?\d+\.\d+)/,
                /!3d(-?\d+\.\d+)!4d(-?\d+\.\d+)/, /^\s*(-?\d+(?:\.\d+)?)\s*,\s*(-?\d+(?:\.\d+)?)\s*$/];
  for (const re of pats) { const m = text.match(re); if (m) { const r = ok(m[1], m[2]); if (r) return r; } }
  return null;
}

/** رابط خرائط جوجل للنقطة — يُبنى هنا من الإحداثيات، لا يُقرأ من الخادم. */
export function googleMapsUrl(lat: number, lon: number): string {
  return `https://www.google.com/maps?q=${lat},${lon}`;
}
